import { render, staticRenderFns } from "./book_loading.vue?vue&type=template&id=44654264&scoped=true&"
import script from "./book_loading.vue?vue&type=script&lang=js&"
export * from "./book_loading.vue?vue&type=script&lang=js&"
import style0 from "./book_loading.vue?vue&type=style&index=0&id=44654264&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44654264",
  null
  
)

export default component.exports